export type PortalModel = {
  cache_key: number,
  export_enabled?: boolean,
  export_format?: string,
  export_logs_supported?: boolean,
  external_ftp?: any,
  id: number,
  import_format?: string,
  internal_ftp?: any,
  options?: {
    batched_image_export_enabled?: boolean,
    export_enabled?: boolean,
    export_logs_supported?: boolean,
  },
  password?: string,
  short_code: string,
  title: string,
  username?: string,
}

const state = {
  export_format: '',
  external_ftp: {},
  id: null,
  import_format: '',
  internal_ftp: {},
  options: {},
  password: '',
  short_code: '',
  title: '',
  username: '',
}

export const requiredFields = [
  { key: 'title' },
  { key: 'short_code' },
]

export default state
